import React, { useState, useEffect } from 'react';
import {
  Grid,
  Container,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useViewTournamentDetailsStyle } from './style';
import { TournamentCalendarModel } from '../../models/tournamentCalendarModel';
import { getTournamentDetailsReq } from '../../api/tournamentCalendar/listApi';
import { BackButton } from '../../components/backButton/backButton';
import moment from 'moment';

export function ViewTournamentDetails() {
  const { t } = useTranslation();
  const tournamentDetailsStyles = useViewTournamentDetailsStyle();
  const { tournamentId } = useParams();
  const [tournament, setTournament] = useState<TournamentCalendarModel>();

  useEffect(() => {
    async function getTournamentDetails() {
      if (!tournamentId?.trim()) return;
      const response = await getTournamentDetailsReq(tournamentId.trim());
      if (response && response.data) {
        setTournament(response.data);
      }
    }
    getTournamentDetails();
  }, [setTournament, tournamentId]);

  return (
    <Container>
      <Grid item xs={12}>
        <Typography component='h5' variant='h5' className={tournamentDetailsStyles.pageTitleGrid}>
          {tournament?.name || ''}
        </Typography>
      </Grid>
      <Grid item xs={12} className={tournamentDetailsStyles.itemContainer}>
        <BackButton tooltipTitle={t('tournaments_calendar')} tooltipPlacement='right' />
        <TableContainer>
          <Table aria-label='tournament data'>
            <TableBody>
              <TableRow
                classes={{
                  root: tournamentDetailsStyles.tableRow,
                }}
              >
                <TableCell component='th' scope='row'>
                  {t('referee')}
                </TableCell>
                <TableCell align='left'>
                  {tournament?.tournamentDirector &&
                    `${tournament.tournamentDirector.preferredGivenName} ${tournament.tournamentDirector.preferredFamilyName}`}
                </TableCell>
              </TableRow>
              <TableRow
                classes={{
                  root: tournamentDetailsStyles.tableRow,
                }}
              >
                <TableCell component='th' scope='row'>
                  {t('name')}
                </TableCell>
                <TableCell align='left'>{tournament?.name}</TableCell>
              </TableRow>
              <TableRow
                classes={{
                  root: tournamentDetailsStyles.tableRow,
                }}
              >
                <TableCell component='th' scope='row'>
                  {t('start_date')}
                </TableCell>
                <TableCell align='left'>
                  {tournament?.start && moment(tournament.start).format('DD.MM.YYYY.')}
                </TableCell>
              </TableRow>
              <TableRow
                classes={{
                  root: tournamentDetailsStyles.tableRow,
                }}
              >
                <TableCell component='th' scope='row'>
                  {t('end_date')}
                </TableCell>
                <TableCell align='left'>
                  {tournament?.end && moment(tournament.end).format('DD.MM.YYYY.')}
                </TableCell>
              </TableRow>
              <TableRow
                classes={{
                  root: tournamentDetailsStyles.tableRow,
                }}
              >
                <TableCell component='th' scope='row'>
                  {t('rank')}
                </TableCell>
                <TableCell align='left'>{tournament?.rank}</TableCell>
              </TableRow>
              <TableRow
                classes={{
                  root: tournamentDetailsStyles.tableRow,
                }}
              >
                <TableCell component='th' scope='row'>
                  {t('category')}
                </TableCell>
                <TableCell align='left'>{tournament?.category}</TableCell>
              </TableRow>
              <TableRow
                classes={{
                  root: tournamentDetailsStyles.tableRow,
                }}
              >
                <TableCell component='th' scope='row'>
                  {t('notes')}
                </TableCell>
                <TableCell align='left'>
                  {tournament?.notes?.split('\n').map((i, key) => {
                    return <div key={key}>{i}</div>;
                  })}
                </TableCell>
              </TableRow>

              {tournament?.officials && tournament.officials.length > 0 && (
                <TableRow
                  classes={{
                    root: tournamentDetailsStyles.tableRow,
                  }}
                >
                  <TableCell component='th' scope='row' colSpan={2}>
                    <Typography variant='h6'>{t('officials')}</Typography>
                  </TableCell>
                </TableRow>
              )}
              {tournament?.officials?.map((official, index) => {
                return (
                  <TableRow
                    key={index}
                    classes={{
                      root: tournamentDetailsStyles.tableRow,
                    }}
                  >
                    <TableCell component='th' scope='row'>
                      {official.role}
                    </TableCell>
                    <TableCell align='left'>{`${official.person.preferredGivenName} ${official.person.preferredFamilyName}`}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Container>
  );
}
